<!-- Project: GSSC Pilot Front-end -->
<!-- Filename: AssetModal.vue -->
<!-- Copyright European Space Agency, 2020 -->
<!-- This file is part of the source code package for contract PO PO 5001024866 -->
<!-- No part of the package, including this file, may be copied, modified,      -->
<!-- propagated, or distributed without prior approval by ESA.                  -->
<template>
  <div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <!-- <div v-if="data.resource_type.picture && data.resource_type.picture != 'None'">
            <img width="25" height="25" :src="data.resource_type.picture" alt="" />
          </div> -->
          <h5 class="modal-title mr-auto ml-1">{{ resource_type }} Details</h5>
          <button
            type="button"
            class="asset__modal-close close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body theme-shadow" :style="iconBackground">
          <div class="asset__modal-group">
            <p v-if="applicable(filename)">
              <span class="text-muted">Filename</span>
              : {{ filename }}
            </p>

            <p v-if="isProcessing">
              <span class="text-muted">Type</span>
              : {{ lab }}
            </p>
            <p v-if="applicable(desc)">
              <span class="text-muted">Description</span>
              : {{ desc }}
            </p>
            <p v-if="applicable(name)">
              <span class="text-muted">Collection</span>
              : {{ name }}
            </p>
            <p v-if="applicable(dataset)">
              <span class="text-muted">Dataset</span>
              : {{ dataset }}
            </p>
            <!-- Resource Class -->
            <p v-if="applicable(data.file_format.resource_class)">
              <span class="text-muted">Resource Class</span>
              : {{ data.file_format.resource_class }}
            </p>
            <!-- Resource Type -->
            <p v-if="applicable(resource_type)">
              <span class="text-muted">Resource Type</span>
              : {{ resource_type }}
            </p>
            <!-- Resource Format -->
            <p v-if="applicable(data.file_format)">
              <span class="text-muted">Resource Format</span>
              : {{ data.file_format.name }}
            </p>
            <!-- Organisation -->
            <p v-if="applicable(organisations)">
              <span class="text-muted">Organisation</span>:
              <span v-for="org in organisations" :key="org" class="badge badge-primary ml-1">{{
                org
              }}</span>
            </p>
            <!-- Tags -->
            <p v-if="applicable(tags)">
              <span class="text-muted">Tags</span>
              :
              <span v-for="tag in tags" :key="tag" class="badge badge-primary ml-1">{{ tag }}</span>
            </p>
            <p v-if="applicable(generation_time)">
              <span class="text-muted">Generation Time</span>
              : {{ generation_time }}
            </p>
            <p v-if="applicable(ingestion_time) && resource_type !== 'Datalab'">
              <span class="text-muted">Ingestion Time</span>
              : {{ ingestion_time }}
            </p>
            <!-- <p v-if="applicable(generation_date)">
              <span class="text-muted">Generation Date</span>
              : {{ generation_date }}
            </p>
            <p v-if="applicable(ingestion_date)">
              <span class="text-muted">Ingestion Date</span>
              : {{ ingestion_date }}
            </p> -->
            <p v-if="applicable(data.path)">
              <span class="text-muted">File Path</span>
              : {{ data.path }}
            </p>
            <p v-if="applicable(access_policy)">
              <span class="text-muted">Access Policy</span>
              : {{ access_policy }}
            </p>
            <div v-if="resource_type == 'Datalab'">
              <p v-if="applicable(datalab_license)">
                <span class="text-muted">Datalab License</span>
                :
                <a v-if="datalab_license.url" :href="datalab_license.url" target="_blank">{{
                  datalab_license.text
                }}</a>
                <span v-else>{{ datalab_license.text }}</span>
                <!-- {{ data.collection.license }} -->
              </p>
            </div>
            <div v-else>
              <p v-if="applicable(license)">
                <span class="text-muted">License</span>
                :
                <a v-if="license.url" :href="license.url" target="_blank">{{ license.text }}</a>
                <span v-else>{{ license.text }}</span>
                <!-- {{ data.collection.license }} -->
              </p>
            </div>
            <p v-if="applicable(doi)">
              <span class="text-muted">DOI</span>
              : {{ doi }}
            </p>
            <p v-if="applicable(data.region)">
              <span class="text-muted">Region</span>
              : {{ data.region }}
            </p>
            <p v-if="applicable(mission)">
              <span class="text-muted">Mission</span>
              : {{ mission }}
            </p>
          </div>
          <div class="asset__modal-group">
            <!-- <h4>Constellations</h4> -->
            <p v-if="applicable(data.constellations)">
              <span class="text-muted">Observed Constellations</span>
              :
              {{ data.constellations }}
            </p>
          </div>
          <div class="asset__modal-group">
            <!-- <h4>Constellations</h4> -->
            <p v-if="applicable(data.satellites)">
              <span class="text-muted">Observed Satellites</span>
              :
              {{ data.satellites }}
            </p>
          </div>
          <div class="asset__modal-group">
            <!-- <h4>Observables</h4> -->
            <p v-if="applicable(data.observables)">
              <span class="text-muted">Observables</span>
              :
              {{ data.observables }}
            </p>
          </div>
          <div v-if="applicable(data.station)" class="asset__modal-group">
            <h4>Station</h4>
            <div>
              <p class="m-0">
                <span class="text-muted">Site Name:</span>
                {{ data.station.site_name }}
              </p>
              <p class="m-0">
                <span class="text-muted">IERS DOMES Number:</span>
                {{ data.station.IERS_DOMES_Number }}
              </p>
              <p class="m-0">
                <span class="text-muted">Agency:</span>
                {{ data.station.agency }}
              </p>
              <p class="m-0">
                <span class="text-muted">ID:</span>
                {{ data.station.id }}
              </p>
            </div>
          </div>
        </div>
        <div class="asset__modal-actions modal-footer">
          <!-- Download -->
          <div class="loader" :class="{ show: ongoingDownload }"></div>
          <button
            title="Download asset"
            type="button"
            class="asset__modal-download btn btn-sm mr-2"
            @click.prevent="download"
            :disabled="ongoingDownload"
          >
            <i class="icon icon-download font-24"></i>
          </button>
          <!-- Open in lab -->
          <div class="d-inline-block mr-2">
            <button
              v-if="auth && isUser"
              :title="isProcessing ? 'Launch' : 'Open in datalab'"
              class="asset__modal-lab btn btn-sm"
              data-dismiss="modal"
              @click.prevent="emitAssetLabModal()"
              :disabled="noLab"
            >
              <i class="icon icon-lab font-24"></i>
            </button>
            <!-- <button
              type="button"
              v-if="auth"
              class="asset__modal-lab btn btn-light btn-sm"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i class="icon icon-lab bold-me"></i>
            </button>
            <div class="dropdown-menu">
              <a
                class="asset__modal-Jupyter-lab dropdown-item"
                href="#"
                v-for="lab in data.asset_labs"
                :key="lab.name"
                @click.prevent="emitAssetLabModal(lab.name)"
                >{{ lab.name }}</a
              >
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import createComponent from '@/models/asset_component';

const component = createComponent();
export default component;
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '~@/styles/globals';

.modal .modal-dialog .modal-content {
  border: none;
  border-radius: $border-radius;

  .modal-header {
    border-radius: $border-radius $border-radius 0 0;
    background: $neutral-space;
  }

  .modal-body {
    border: none;
  }

  .modal-footer {
    border-radius: 0 0 $border-radius $border-radius;
    border: none;
    background-color: $primary;
    align-items: flex-start;

    button {
      color: $white-ghost;

      &:hover {
        color: $main;
      }
    }

    // Spinner styles
    .loader {
      display: none;
      margin-top: 8px;
      margin-right: 14px;
      //display: inline-block;
      border: 5px solid #e9ecef;
      /* Light grey */
      border-top: 5px solid $deep-space;
      /* Blue */
      border-radius: 50%;
      width: 22px;
      height: 22px;
      animation: spin 2s linear infinite;

      &.show {
        display: block;
      }
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }

      100% {
        transform: rotate(360deg);
      }
    }
  }
}

.asset__modal-actions {
  display: flex;

  .icon {
    padding: 0;
  }
}

.asset__modal-group {
  h4 {
    font-size: 1.3rem !important;
    font-weight: bold !important;
    color: $black-85 !important;
  }

  p {
    margin-bottom: 4px;
  }
}

.asset__modal-close {
  position: absolute;
  right: 1rem;
  top: 1rem;
  // background-color: green;
  border-radius: 0.3rem;
  opacity: 1;

  span {
    opacity: 0.8;
    color: $deep-space;
  }

  &:hover {
    opacity: 1 !important;

    span {
      color: $deep-space;
      opacity: 1;
    }
  }
}
</style>
